import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLegal } from '../context/LegalContext';
import '../styles/legal.css';

const CookieBanner = () => {
  const { bannerVisible, acceptCookies, rejectCookies, openLegalModal } = useLegal();

  return (
    <AnimatePresence>
      {bannerVisible && (
        <motion.div
          className="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          role="dialog"
          aria-live="polite"
          aria-label="Aviso de uso de cookies"
          data-testid="cookie-banner"
        >
          <div className="cookie-banner-inner">
            <div className="cookie-banner-text">
              <strong>Este sitio utiliza cookies.</strong>{' '}
              Usamos cookies técnicas necesarias para el funcionamiento del sitio y, si aceptas,
              cookies de análisis para entender cómo se utiliza la web. Puedes aceptar, rechazar
              o consultar más información en nuestra política.
            </div>
            <div className="cookie-banner-actions">
              <button
                type="button"
                className="cookie-btn cookie-btn-primary"
                onClick={acceptCookies}
                data-testid="cookie-accept-btn"
              >
                Aceptar
              </button>
              <button
                type="button"
                className="cookie-btn cookie-btn-primary"
                onClick={rejectCookies}
                data-testid="cookie-reject-btn"
              >
                Rechazar
              </button>
              <button
                type="button"
                className="cookie-btn cookie-btn-link"
                onClick={() => openLegalModal('politica-cookies')}
                data-testid="cookie-more-info-btn"
              >
                Más información
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
